function subjectNameKey(subName) {
    return String(subName || "")
        .trim()
        .toLowerCase();
}

function subjectDedupeScore(row) {
    if (row?.teacherId || row?.teacher?._id || row?.teacher?.id || row?.teacher?.name) return 2;
    return 0;
}

function mergeSubjectDuplicateRows(a, b) {
    const preferred = subjectDedupeScore(b) > subjectDedupeScore(a) ? b : a;
    const other = preferred === a ? b : a;
    return {
        ...preferred,
        teacherId: preferred.teacherId || other.teacherId || null,
        teacher: preferred.teacher || other.teacher || null,
    };
}

/** One entry per subject name; merge teacher from any duplicate row. */
export function dedupeSubjectsByName(subjects) {
    if (!Array.isArray(subjects)) return [];
    const byName = new Map();
    for (const row of subjects) {
        const key = subjectNameKey(row?.subName);
        if (!key) continue;
        const existing = byName.get(key);
        byName.set(key, existing ? mergeSubjectDuplicateRows(existing, row) : row);
    }
    return [...byName.values()];
}

/** Display label for a subject's assigned teacher, if any. */
export function getSubjectTeacherLabel(subject) {
    if (subject?.teacher?.name) return subject.teacher.name;
    if (subject?.teacherName) return subject.teacherName;
    if (subject?.teacherId) return "Assigned";
    return "Unassigned";
}

export { subjectNameKey };

/** One entry per id, then by name. */
export function dedupeSubjectsById(subjects) {
    if (!Array.isArray(subjects)) return [];
    const byId = new Map();
    for (const row of subjects) {
        const id = String(row?._id || row?.id || "").trim();
        if (id && !byId.has(id)) byId.set(id, row);
    }
    const list = byId.size ? [...byId.values()] : subjects;
    return dedupeSubjectsByName(list);
}
